// Scoped disclosure: native details/summary, no parallel header or cart behavior.
function initializeJourneyMenu() {
  document.querySelectorAll('header-menu[data-sown-journey]').forEach((menu) => {
    initialize.call(menu);
  });
}
function initialize() {
    if (this.ready) return;
    this.ready = true;
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.closeJourney = (restoreFocus = false) => {
      this.details.open = false;
      this.summary.setAttribute('aria-expanded', 'false');
      if (restoreFocus) this.summary.focus();
    };
    this.details.addEventListener('toggle', () => {
      this.summary.setAttribute('aria-expanded', String(this.details.open));
      if (this.details.open) {
        document.querySelectorAll('header-menu > details').forEach((other) => {
          if (other !== this.details) {
            other.open = false;
            other.querySelector('summary')?.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.details.open) {
        event.preventDefault(); event.stopPropagation(); this.closeJourney(true);
      }
    });
    this.addEventListener('focusout', () => {
      setTimeout(() => { if (!this.contains(document.activeElement)) this.closeJourney(); }, 0);
    });
    this.addEventListener('mouseenter', () => {
      if (matchMedia('(hover: hover)').matches) this.details.open = true;
    });
    this.addEventListener('mouseleave', () => {
      if (!this.contains(document.activeElement)) this.closeJourney();
    });
    this.outside = (event) => { if (!this.contains(event.target)) this.closeJourney(); };
    document.addEventListener('pointerdown', this.outside);
    // Native sibling menus may open by keyboard, hover or programmatic toggle.
    this.siblingToggle = (event) => {
      if (!event.target.matches('header-menu > details')) return;
      if (event.target !== this.details && event.target.open) this.closeJourney();
      // Native sibling handlers run after capture. Reconcile from the whole
      // header after those handlers, not from the last toggled disclosure.
      setTimeout(() => {
        const section = this.closest('.section-header');
        const header = section?.querySelector('.header-wrapper');
        const anyOpen = !!section?.querySelector('header-menu > details[open]');
        if (header) header.preventHide = anyOpen;
        section?.classList.toggle('menu-is-open', anyOpen);
      }, 0);
    };
    document.addEventListener('toggle', this.siblingToggle, true);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeJourneyMenu);
else initializeJourneyMenu();
